export const compressImageFile = (file, options = {}) => {
  const {
    maxWidth = 512,
    maxHeight = 512,
    quality = 0.82,
    outputType = 'image/jpeg'
  } = options;

  if (!(file instanceof File) || !file.type.startsWith('image/')) {
    return Promise.resolve(file);
  }

  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onerror = () => reject(new Error('画像ファイルの読み込みに失敗しました。'));
    reader.onload = () => {
      const image = new Image();

      image.onerror = () => reject(new Error('画像の解析に失敗しました。'));
      image.onload = () => {
        let { width, height } = image;
        const scale = Math.min(maxWidth / width, maxHeight / height, 1);

        width = Math.max(1, Math.round(width * scale));
        height = Math.max(1, Math.round(height * scale));

        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;

        const context = canvas.getContext('2d');
        if (!context) {
          reject(new Error('画像圧縮の初期化に失敗しました。'));
          return;
        }

        context.drawImage(image, 0, 0, width, height);

        canvas.toBlob(
          (blob) => {
            if (!blob) {
              reject(new Error('画像の圧縮に失敗しました。'));
              return;
            }

            const extension = outputType === 'image/png' ? 'png' : 'jpg';
            const compressedFile = new File(
              [blob],
              replaceFileExtension(file.name, extension),
              {
                type: outputType,
                lastModified: Date.now()
              }
            );

            resolve(compressedFile.size < file.size ? compressedFile : file);
          },
          outputType,
          quality
        );
      };

      image.src = reader.result;
    };

    reader.readAsDataURL(file);
  });
};

const replaceFileExtension = (fileName, nextExtension) => {
  const baseName = fileName.replace(/\.[^.]+$/, '');
  return `${baseName}.${nextExtension}`;
};
